class Translation {

  constructor () {
    this.transMap = {
      student: '学生',
      father: '爸爸',
      mother: '妈妈',
      parents: '家长',
      others: '其他',
      todo: '未完成',
      done: '已完成'
    }
  }

  trans (key) {
    return this.transMap[key]
  }

}

export let t = new Translation()



// WEBPACK FOOTER //
// ./src/modules/Translation.js